/**
 * Product dropdown functionality
 */

/**
 * Initialize the product dropdown functionality
 */
function initProductDropdown() {
    const productMenu = document.querySelector('.product-menu');
    const productDropdown = document.querySelector('.product-dropdown');

    if (productMenu && productDropdown) {
        // Toggle dropdown on click
        productMenu.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Toggle the dropdown
            if (productDropdown.classList.contains('show')) {
                productDropdown.classList.remove('show');
                productDropdown.classList.add('hide');
            } else {
                productDropdown.classList.remove('hide');
                // Force reflow to ensure the transition works
                void productDropdown.offsetWidth;
                productDropdown.classList.add('show');
            }
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
            if (!productMenu.contains(e.target) && !productDropdown.contains(e.target)) {
                productDropdown.classList.remove('show');
                productDropdown.classList.add('hide');
            }
        });

        // Close dropdown when clicking on a link inside the dropdown
        const dropdownLinks = productDropdown.querySelectorAll('a');
        dropdownLinks.forEach(link => {
            link.addEventListener('click', function() {
                productDropdown.classList.remove('show');
                productDropdown.classList.add('hide');
            });
        });
    }
}

export { initProductDropdown };
